import { Timestamp } from '@dixa/lib-shared-habla';
import { ArticleFullFieldsFragment } from 'lib-knowledge-management-common/graphql';

import InfoItem from './infoItem';

type User = ArticleFullFieldsFragment['createdBy'];

type Props = {
  labelPrefix: string;
  by: User;
  at: number;
};

const TimeAgo = ({ at, by, labelPrefix }: Props): JSX.Element => {
  return (
    <InfoItem>
      {labelPrefix}&nbsp;{by?.name || 'unknown user'}
      <br />
      <Timestamp time={at / 1000} refreshRate={60000} relative={true} />
    </InfoItem>
  );
};

export default TimeAgo;
